import { ReactNode } from 'react';
import { create } from 'zustand';

export type ModalKeys =
  | 'TC'
  | 'PRIVACY'
  | 'STAMP_CARD'
  | 'LOCATION'
  | 'STATION'
  | 'AREA'
  | 'STATION_LOCKER'
  | 'USC_BOOKINGS'
  | 'DISCOUNT'
  | 'COMPANY_MODAL'
  | 'CHECKIN'
  | 'CONFIRMATION'
  | 'USC_WEBHOOKS'
  | 'MANUAL_BOOKING'
  | 'RESCHEDULE'
  | 'SCHEDULE_OVERRIDE'
  | 'CHECKOUT'
  | 'EMERGENCY_UNLOCK_ALL'
  | 'EDIT_EMAIL'
  | 'DIAGNOSTIC_RESULT';

export interface ModalComponentProps {
  handleClose: () => void;
}
export interface ModalState {
  key: ModalKeys | null;
  content: ReactNode;
}

const initModal: ModalState = {
  key: null,
  content: null,
};

export type ModalStore = {
  modal: ModalState;
  setModal: (modal: ModalState) => void;
  resetModal: () => void;
};

export const useModalStore = create<ModalStore>((set) => ({
  modal: initModal,
  setModal: (modal: ModalState) => set({ modal }),
  resetModal: () => set({ modal: initModal }),
}));
